import { apiClient } from './authService';

const categoryService = {
  // Get all categories
  getAllCategories: async () => {
    try {
      // Using the products category API endpoint
      const response = await apiClient.get('products/categories/');
      console.log('Raw API response:', response.data);
      // Handle API response structure which includes status and results
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error.response?.data || { message: 'Error fetching categories' };
    }
  },

  // Get category by ID
  getCategoryById: async (id) => {
    try {
      const response = await apiClient.get(`products/categories/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching category ${id}:`, error);
      throw error.response?.data || { message: 'Error fetching category details' };
    }
  },

  // Create new category
  createCategory: async (categoryData) => {
    try {
      const response = await apiClient.post('products/categories/', categoryData);
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error.response?.data || { message: 'Error creating category' };
    }
  },

  // Update category
  updateCategory: async (id, categoryData) => {
    try {
      const response = await apiClient.put(`products/categories/${id}/`, categoryData);
      return response.data;
    } catch (error) {
      console.error(`Error updating category ${id}:`, error);
      throw error.response?.data || { message: 'Error updating category' };
    }
  },

  // Delete category
  deleteCategory: async (id) => {
    try {
      const response = await apiClient.delete(`products/categories/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting category ${id}:`, error);
      throw error.response?.data || { message: 'Error deleting category' };
    }
  }
};

export default categoryService;
